module.exports = __webpack_public_path__ + "static/media/emlap_logo.623073fc.png";